import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router doesn't reset scroll position on navigation the way a full page load does —
 * without this, visiting a new route (or clicking back/forward) leaves the viewport wherever
 * it was on the previous page. Mounted once near the router root.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
